export default "__VITE_ASSET__677050a3__"